import * as types from './action-types';
import { formatTimeslots, getPreferredTimeslotIndex, formatTimeWindows } from './operations';

const rescheduleModalState = {
  isLoading: false,
  isFlexibleDelivery: true,
  hasLoaded: false,
  schedulerIsLoaded: false,
  preferredTimeslotIndex: null,
  selectedTimeSlot: {
    endRange: '',
    optionId: '',
    routeId: '',
    time: ''
  },
  timeZone: '',
  transferType: '',
  timeSlots: [],
  timeWindows: []
};

const reducer = (state = rescheduleModalState, action) => {
  const { type, payload } = action;

  switch (type) {
    case `${types.GET_TRANSFER_SCHEDULE_TIMESLOTS}_LOADING`:
      return {
        ...state,
        isLoading: true,
        schedulerIsLoaded: false
      };

    case `${types.GET_TRANSFER_SCHEDULE_TIMESLOTS}_SUCCESS`: {
      if (!payload?.timeSlots) {
        return {
          ...state,
          schedulerIsLoaded: true,
          isLoading: false,
          error: payload
        }
      }
      const { activityType, timeZone } = payload.timeSlots[0];
      const timeSlots = formatTimeslots(payload?.timeSlots);

      const timeWindows = formatTimeWindows(payload?.timeWindows);
      const isFlexibleDelivery = payload?.displayTimeWindows;

      return {
        ...state,
        transferType: activityType.toLowerCase(),
        schedulerIsLoaded: true,
        isLoading: false,
        preferredTimeslotIndex: getPreferredTimeslotIndex(
          payload?.preferredDate,
          timeSlots,
          timeWindows
          ),
        timeSlots,
        timeZone,
        timeWindows,
        isFlexibleDelivery
      };
    }

    case `${types.GET_TRANSFER_SCHEDULE_TIMESLOTS}_ERROR`:
      return {
        ...state,
        error: payload,
        isLoading: false,
        schedulerIsLoaded: false
      };

    case types.TIME_SLOT_DATE_SELECTED:
      return {
        ...state,
        selectedTimeSlot: {
          date: payload
        }
      };

    case `${types.TIME_SLOT_SUBMIT}_LOADING`:
      return {
        ...state,
        isLoading: true
      };

    case `${types.TIME_SLOT_SUBMIT}_SUCCESS`:
      return {
        ...state,
        isLoading: false,
        schedulerIsLoaded: false
      };

    case `${types.TIME_SLOT_SUBMIT}_ERROR`:
      return {
        ...state
      };

    case types.TIME_SLOT_TIME_SELECTED:
      return {
        ...state,
        selectedTimeSlot: {
          ...state.selectedTimeSlot,
          endRange: payload?.endRange,
          optionId: payload?.optionId,
          routeId: payload?.routeId,
          time: payload?.time
        }
      };

    case types.RESCHEDULE_MODAL_CLOSED:
      return {
        ...state,
        schedulerIsLoaded: false
      };

    default:
      return state;
  }
};

export default reducer;
